<template>
  <path
    d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V10.2275C12.75 12.2075 11.5219 13.9805 9.66797 14.6758C8.59264 15.079 7.40736 15.079 6.33203 14.6758C4.47811 13.9805 3.25 12.2075 3.25 10.2275V7C3.25 6.58579 3.58579 6.25 4 6.25C4.41421 6.25 4.75 6.58579 4.75 7V10.2275C4.75 11.5822 5.59006 12.7957 6.8584 13.2715C7.59415 13.5474 8.40585 13.5474 9.1416 13.2715C10.4099 12.7957 11.25 11.5822 11.25 10.2275V2C11.25 1.58579 11.5858 1.25 12 1.25Z"
    fill="#868D9C"
  />
  <path
    d="M8 3.25C8.41421 3.25 8.75 3.58579 8.75 4V10.5C8.75 10.9142 8.41421 11.25 8 11.25C7.58579 11.25 7.25 10.9142 7.25 10.5V4C7.25 3.58579 7.58579 3.25 8 3.25Z"
    fill="#868D9C"
  />
</template>
